import React from 'react';
import {useSelector} from 'react-redux';

import {Box} from '@spothero/ui';

import WithConfig from 'hooks/config/WithConfig';

import DevMode from './content/DevMode';
import ProductionMode from './content/ProductionMode';
import errorBoundaryProps from './error-boundary.props';

import {
    domainErrorDisplayContainerStyleProps,
    errorDisplayCardStyleProps,
} from './error-display-style.props';

const ErrorDisplay = ({error, componentStack, resetError, isProduction}) => {
    const {is_staff: isStaff} = useSelector((state) => state.user.data);

    return (
        <Box
            data-testid="DomainErrorDisplay"
            {...domainErrorDisplayContainerStyleProps}
        >
            <Box {...errorDisplayCardStyleProps}>
                {!isProduction && isStaff ? (
                    <DevMode
                        error={error}
                        componentStack={componentStack}
                        resetError={resetError}
                    />
                ) : (
                    <ProductionMode />
                )}
            </Box>
        </Box>
    );
};

ErrorDisplay.propTypes = errorBoundaryProps;

export default WithConfig(ErrorDisplay);
